import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrmsCalendarWorkTime/mocker'

export default {
  getTypwork ({ codempid, year }) {
    if (isMock) return generator(mocker.typwork({ codempid, year }))
    return instance().get(endpoint + '/hrmsCalendarWorkTime/getTypwork/' + codempid + '/' + year)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsCalendarWorkTime/index.js